const Paymentpage=(props)=>{
    const SendEmail=()=>{

    }
    return(
        <div className="w-full flex justify-center">
            <div className='w-72 md:w-105  bg-slate-100 rounded-2xl px-3 py-5'>
                <div>You are Make Payment for 15days</div>
                <div>From 12 June,2024</div>
                <div>End 26 June,2024</div>
                <div>Total Amount:20.05 GBP</div>
                <div className="text-center font-bold fredoka">Check Your Email for Payment details</div>
                <div className="flex justify-center"><div className="bg-bluecolor rounded-2xl text-white w-8 h-8 items-center">Ok</div></div>

                </div>
                </div>
    )
}
export default Paymentpage